import React from "react";
import { useT } from "@/lib/LanguageContext";
import { CRM } from "../../../../constants/testIds/crm";

/**
 * One rendered email (`POST /api/automation/preview`'s answer, or a broadcast preview's
 * `rendered`): the sender and subject lines a mail client shows, then the body exactly as
 * sent, in an iframe with `sandbox=""` — no scripts, no forms, no navigation of this page,
 * and the email's own styles cannot leak into the admin (or the admin's into it).
 *
 * @param {{ email: { subject: string, body_html: string, from_address: string } }} props
 */
export default function EmailPreviewFrame({ email }) {
  const t = useT("crm");
  return (
    <div className="space-y-2">
      <dl className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 text-sm">
        <dt className="text-eh-muted">{t("emailPreview.from")}</dt>
        <dd className="text-eh-ink break-all" data-testid={CRM.emailPreviewFrom}>{email.from_address}</dd>
        <dt className="text-eh-muted">{t("emailPreview.subject")}</dt>
        <dd className="font-medium text-eh-ink" data-testid={CRM.emailPreviewSubject}>{email.subject}</dd>
      </dl>
      <iframe title={t("emailPreview.frameTitle")} sandbox="" srcDoc={email.body_html || ""}
        data-testid={CRM.emailPreviewFrame}
        className="h-[50vh] w-full rounded-2xl border border-eh-border-soft bg-white" />
      <p className="text-xs text-eh-muted">{t("emailPreview.sampleNote")}</p>
    </div>
  );
}
